import { useEffect, useState } from 'react';
import api from '../../Component/axios_Interceptor/api';
import { SERVER_ADDRESS } from '../../Component/server';

const changed = 'fanbird:chat-mute-updated';
export function publishChatMute(nickname: string, muted: boolean) {
  window.dispatchEvent(new CustomEvent(changed, { detail: { nickname, muted } }));
}

export default function useChatMuteMask(liveSeq: number | undefined, enabled: boolean) {
  const [nicknames,setNicknames] = useState(new Set<string>());
  useEffect(() => {
    setNicknames(new Set());
    if (!enabled || !liveSeq) return;
    let active=true, busy=false;
    // Preserve confirmed local updates if an older list request finishes later.
    const updates=new Map<string,boolean>();
    const apply=(event:Event) => {
      const detail=(event as CustomEvent).detail;
      if (typeof detail?.nickname!=='string' || typeof detail.muted!=='boolean') return;
      updates.set(detail.nickname,detail.muted);
      setNicknames(current=>{const next=new Set(current);if(detail.muted)next.add(detail.nickname);else next.delete(detail.nickname);return next;});
    };
    const load=async()=>{
      if(busy)return;busy=true;
      try {
        const loaded=new Set<string>();
        for(let page=1;active;page++) {
          const {data}=await api.get(`${SERVER_ADDRESS}relation/chat-muted-user-list`,{params:{current_page:page,per_page:100},timeout:10000});
          if(!active)return;
          if(!Array.isArray(data?.userList)||!Number.isSafeInteger(data.total)||data.total<0)throw new Error('Invalid mute list');
          data.userList.forEach((row:{nickname?:string})=>{if(typeof row.nickname==='string')loaded.add(row.nickname);});
          if(page*100>=data.total)break;
          if(!data.userList.length)throw new Error('Incomplete mute list');
        }
        if(!active)return;
        updates.forEach((muted,nickname)=>{if(muted)loaded.add(nickname);else loaded.delete(nickname);});
        setNicknames(loaded);
      } catch { /* Keep the last confirmed state while the server reconnects. */ }
      finally {busy=false;}
    };
    window.addEventListener(changed,apply);window.addEventListener('focus',load);void load();
    return()=>{active=false;window.removeEventListener(changed,apply);window.removeEventListener('focus',load);};
  },[liveSeq,enabled]);
  return nicknames;
}
